/** Tokens visuais — controle de acesso (marca TNV) */
export const ACESSO_ACCENT = "#F96030";
export const ACESSO_INK = "#1a2035";

export const acessoToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${ACESSO_ACCENT}`,
};

export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
  },
};

export const emptyStateSx = {
  py: 6,
  textAlign: "center",
  border: "1px dashed",
  borderColor: "grey.300",
  borderRadius: 2,
  bgcolor: "grey.50",
};

export const saveButtonSx = {
  background: `linear-gradient(195deg, ${ACESSO_ACCENT}, #e04a1a)`,
};

export const modalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 720,
};

export const modalHeaderSx = {
  px: 3,
  py: 2.5,
  flexShrink: 0,
  background: `linear-gradient(135deg, ${ACESSO_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${ACESSO_ACCENT}`,
};

export const gridSx = {
  minHeight: 480,
  "& .MuiDataGrid-cell": {
    display: "flex",
    alignItems: "center",
  },
};

export const actionIconSx = {
  color: ACESSO_ACCENT,
  "&:hover": { bgcolor: "rgba(249, 96, 48, 0.08)" },
};

export const infoBannerSx = {
  p: 1.5,
  borderRadius: 1.5,
  bgcolor: "rgba(249, 96, 48, 0.06)",
  border: "1px solid",
  borderColor: "rgba(249, 96, 48, 0.2)",
};

export const checkboxSx = {
  "&.Mui-checked": { color: ACESSO_ACCENT },
};
